import React, { useEffect } from "react";
import { ImageBackground } from "react-native";
import { useSelector } from "react-redux";
import BackgroundImage from "@assets/images/header/header_background.png";
import LargeWidget from "./LargeWidget";
import SmallWidget from "./SmallWidget";
import ExtraLargeWidget from "./ExtraLargeWidget";
import Banner from "./Banner";
import ReconInfo from "@screens/ReconInfo";
import TodaysProgress from "./TodaysProgress";
import OfferWidget from "./OfferWidget";
import BannerList from "./BannerList";
import InfoCards from "./InfoCards";
import KycEnforcingWidget from "./KycEnforcingWidget";
import GigsWidget from "./GigsWidget";
import { ScaledSheet } from "@utils/scale";

const HomePageWidget = () => {
  useEffect(() => {}, [widgets]);
  const { widgets = {} } = useSelector((state) => state.homePageWidget);
  // CP-DB KYC enforcing (docs/cp-features/cp-db-kyc-enforcing): if a blocked KYC
  // card is present, render ONLY it so the delivery widgets can never be tapped
  // — defensive against any transient state where they briefly coexist.
  const widgetKeys = Object.keys(widgets);
  const blockedKycKey = widgetKeys.find(
    (k) => widgets[k]?.widget_type === "KYC_ENFORCING" && widgets[k]?.blocked,
  );
  const keysToRender = blockedKycKey ? [blockedKycKey] : widgetKeys;
  return (
    <ImageBackground
      source={BackgroundImage}
      resizeMode="cover"
      style={styles.background}
      imageStyle={{ height: "50%" }}
    >
      {keysToRender.map((widgetKey) => {
        const item = widgets[widgetKey];
        switch (item?.widget_type) {
          case "BANNER":
            return <Banner key={widgetKey} item={item} />;
          case "BANNER_LIST":
            return (
              <BannerList
                key={widgetKey}
                data={item?.value}
                onPress={(item, index) =>
                  console.log("Pressed banner", index, item)
                }
              />
            );
          case "INFO_CARDS":
            return <InfoCards key={widgetKey} data={item} />;
          case "EXTRA_LARGE_BOX":
            return <ExtraLargeWidget key={widgetKey} item={item} />;
          case "LARGE_BOX":
            return <LargeWidget key={widgetKey} item={item} />;
          case "WEEKLY_OFFER":
            return <OfferWidget key={widgetKey} data={item} />;
          case "TODAY_OFFER":
            return <OfferWidget key={widgetKey} data={item} />;
          case "SPECIAL_OFFER":
            return <OfferWidget key={widgetKey} data={item} />;
          case "RECON_INFO":
            return <ReconInfo key={widgetKey} item={item} />;
          case "TODAYS_PROGRESS":
            return <TodaysProgress key={widgetKey} item={item} />;
          case "KYC_ENFORCING":
            return <KycEnforcingWidget key={widgetKey} item={item} />;
          case "GIGS":
            return <GigsWidget key={widgetKey} item={item} />;
          case "SMALL_BOX":
          default:
            return <SmallWidget key={widgetKey} item={item} />;
        }
      })}
    </ImageBackground>
  );
};

export default HomePageWidget;

const styles = ScaledSheet.create({
  background: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    paddingHorizontal: 10,
  },
});
